import { useState } from "react";

import { PrimaryButton } from "@shared/buttons";
import { TextInput } from "@shared/text-input";

import { useFormulaBuilder } from "../hooks/use-formula-builder";

interface Props {
  isDisabled?: boolean;
}

// TODO: Move to @components/v2 and use select from v2 components.
export const MagicNumberInput = ({ isDisabled }: Props) => {
  const [numberToInsert, setNumberToInsert] = useState("");
  const { addNumberOperand } = useFormulaBuilder();

  const isNumberToInsertNaN = Number.isNaN(numberToInsert);

  return (
    <div className="p-4 flex flex-col border border-b-gray-2 border-x-0 border-t-0">
      <div className="text-gray+2 text-xs font-medium tracking-wider mb-2">
        INSERT NUMBER
      </div>
      <div className="flex items-center space-x-2">
        <TextInput
          className="text-sm"
          isDisabled={isDisabled}
          value={Number.isNaN(numberToInsert) ? "" : numberToInsert}
          type="number"
          onChange={({ target }) => setNumberToInsert(target.valueAsNumber)}
          placeholder="Type number..."
        />
        <PrimaryButton
          onClick={() => {
            addNumberOperand(numberToInsert);
            setNumberToInsert("");
          }}
          disabled={isDisabled || isNumberToInsertNaN}
        >
          INSERT
        </PrimaryButton>
      </div>
    </div>
  );
};
